module.exports = __webpack_public_path__ + "static/img/buqian.635e7a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buqian.png
// module id = gpd2
// module chunks = 1